import React from 'react';
// Components
import ScheduledStreamsTable from 'components/common/ScheduledStreamsTable';

const ManageContentCreatorScheduledStreams: React.FC = () => {
  return <ScheduledStreamsTable />;
};

export default ManageContentCreatorScheduledStreams;
